export const MARKERS_NAMES = [
  "1", "2", "3", "4",
  "5", "6", "7", "8",
  "9", "10", "20", "30",
  "40", "50", "60", "70",
  "80", "90", "100", "200",
  "500", "1000", "3000", "5000",
  "6000", "10000", "20000",
];
export const ICON_MAPPING = MARKERS_NAMES.reduce(
  (acc, curr, i) => {
    const x = (i % 4) * 128;
    const y = Math.floor(i / 4) * 127.5;
    return {...acc, [`marker-${curr}`]: {x, y, width: 83, height: 122, anchorY: 122}}
  },
  {} as Record<string, any>
)